<template>
  <div>
    <div class="card">
      <v-overlay :value="overlay" class="text-center" absolute>
        <h3 class="card-title mb-3 text-white font-weight-bold">El proceso puede tardar un par de minutos, por favor espere.</h3>
        <v-progress-circular indeterminate size="100" class="mt-3"></v-progress-circular>
      </v-overlay>
      <div class="card-content pl-4 pr-4">
        <v-row class="pa-4" justify="space-between">
          <h4 class="card-title mb-0">Activación Anual </h4>
          <v-btn color="primary" outlined small class="mt-2 mb-0" @click.prevent="runCron">
            <!-- <v-icon>power_settings_new</v-icon> -->
            Ejecutar
          </v-btn>
        </v-row>
        <v-row class="pa-4 mt-0" justify="space-between">
          <v-col cols="12">

            <v-sheet class="pa-4 primary ">

              <v-text-field v-model="search" label="Buscar dependencia" dark flat solo-inverted hide-details clearable clear-icon="mdi-close-circle-outline"></v-text-field>
            </v-sheet>
          </v-col>
        </v-row>
        <v-row class="pa-4 mt-0" justify="space-between">
          <v-col cols="6">
            <v-treeview :active.sync="active" :filter="filter" activatable :items="items" :search="search" loading-icon="fas fa-circle-notch fa-spin" :open.sync="open" color="primary" open-on-click transition return-object @update:active="getJsonFile">
              <template v-slot:prepend="{ item, active}">
                <v-icon v-if="!item.children" :color="active ? 'primary':''">
                  all_inbox
                </v-icon>
              </template>
              <template v-slot:label="{item,leaf }">
                <div v-if="leaf">
                  {{removeslash(item.name)}}
                </div>
                <div v-else>
                  {{item.name}}
                </div>
              </template>
            </v-treeview>
          </v-col>

          <v-divider vertical></v-divider>

          <v-col class="d-flex text-center">
            <v-scroll-y-transition mode="out-in">
              <v-card v-if="!selected" class="pt-6 mx-auto" flat outlined width="100%">
                <v-progress-circular :size="50" color="primary" indeterminate v-if="loaddata"></v-progress-circular>
                <div class="text-h6 grey--text text--lighten-1 font-weight-light" style="align-self: center;">
                  Seleccione un elemento
                </div>
              </v-card>
              <v-card v-else :key="selected.id" class="pt-0 mx-auto" flat outlined width="100%">
                <v-progress-circular :size="50" color="primary" indeterminate v-if="loaddata"></v-progress-circular>
                <v-card-text>
                  <h3 class="text-h5 mb-2 mt-2">
                    {{ filterCatalog(fileInfo.ente_publico_id, dependencias) }}
                  </h3>
                </v-card-text>
                <v-divider class="m-0 p-0 mb-2"></v-divider>
                <v-row class="text-left m-0 p-0" tag="v-card-text">
                  <v-col class="text-left m-0" tag="strong" cols="12">
                    <export-excel class="btn btn-wd btn-success" :data="dataExcelRegistro" :meta="meta" :fields="campos_excel" worksheet="Padron" :name="file_name+'_registro.xls'">
                      <span class="btn-label">
                        <i class="fa fa-file-excel"></i>
                      </span>
                      Registros
                    </export-excel>
                  </v-col>
                  <v-col>
                    <v-data-table :headers="headers" :items="fileInfo.registros" :items-per-page="10" class="elevation-1">
                      <template v-slot:item.rfc="{ item }">
                        <div class="text-left">{{item.rfc}} </div>
                      </template>
                    </v-data-table>
                    <!-- <v-list>
                      <v-list-item-group active-class="primary--text">
                        <template v-for="(item, index) in fileInfo.registros">
                          <v-list-item :key="item.rfc">
                            <template v-slot:default="{ active }">
                              <v-list-item-content>
                                <v-list-item-title v-text="item.rfc"></v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                          <v-divider v-if="index < fileInfo.registros.length - 1" :key="index" class="m-0 p-0 mb-2"></v-divider>
                        </template>
                      </v-list-item-group>
                    </v-list> -->
                  </v-col>
                  <v-col class="text-left m-0" tag="strong" cols="12">
                    <export-excel class="btn btn-wd btn-success" :data="dataExcelSinMovimientos" :meta="meta" :fields="campos_excel" worksheet="Padron" :name="file_name+'_sin_movimientos.xls'">
                      <span class="btn-label">
                        <i class="fa fa-file-excel"></i>
                      </span>
                      Sin Movimientos
                    </export-excel>
                  </v-col>
                  <v-col>
                    <v-data-table :headers="headers" :items="fileInfo.sinMovimientos" :items-per-page="10" class="elevation-1">
                      <template v-slot:item.rfc="{ item }">
                        <div class="text-left">{{item.rfc}} </div>
                      </template>
                    </v-data-table>

                  </v-col>
                  <v-col class="text-left m-0" tag="strong" cols="12">
                    <export-excel class="btn btn-wd btn-success" :data="dataExcelErrores" :meta="meta" :fields="campos_excel" worksheet="Padron" :name="file_name+'_errores.xls'">
                      <span class="btn-label">
                        <i class="fa fa-file-excel"></i>
                      </span>
                      Errores
                    </export-excel>
                  </v-col>
                  <v-col>
                    <v-data-table :headers="headers" :items="fileInfo.errores" :items-per-page="10" class="elevation-1">
                      <template v-slot:item.rfc="{ item }">
                        <div class="text-left">{{item.rfc}} </div>
                      </template>
                    </v-data-table>

                  </v-col>
                </v-row>
              </v-card>
            </v-scroll-y-transition>
          </v-col>

        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment';
  import Vue from 'vue';
  import excel from 'vue-excel-export';
  export default {
    components: {

    },
    data() {
      return {
        overlay: false,
        periodos: [],
        dependencias: [],
        directorios: [],
        active: [],
        open: [],
        search: '',
        caseSensitive: false,
        loaddata: false,
        fileInfo: {},
        headers: [{
          text: 'RFC',
          align: 'center',
          sortable: false,
          value: 'rfc',
        }, ],
        dataExcelRegistro: [],
        dataExcelSinMovimientos: [],
        dataExcelErrores: [],
        meta: [
          [{
            'key': 'charset',
            'value': 'utf-8'
          }]
        ],
        campos_excel: {
          'RFC': 'rfc',
        },
        file_name: '',
      }
    },
    watch: {
      '$route': 'checkPermissions'
    },
    computed: {
      items() {
        return [{
          name: 'Arbol de Actualización',
          children: this.directorios,
        }, ]
      },
      filter() {
        return this.caseSensitive ?
          (item, search, textKey) => item[textKey].indexOf(search) > -1 :
          undefined
      },
      selected() {
        if (!this.active.length) return undefined;

        const id = this.active[0];

        return true; // this.users.find(user => user.id === id)
      },
    },
    methods: {
      // async fetchUsers(item) {
      //   await pause(1500)
      //   return fetch('https://jsonplaceholder.typicode.com/users')
      //     .then(res => res.json())
      //     .then(json => (item.children.push(...json)))
      //     .catch(err => console.warn(err))
      // },
      removeslash(item) {
        return item.split("/")[1];
      },
      dateFormat: function (date) {
        return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
      },
      dateFormat2: function (date) {
        return moment(date, 'DD-MM-YYYY').format('DD/MM/YYYY');
      },
      dateFormat3: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
      },
      checkPermissions() {
        let permiso = [27];
        if (!this.getKey('permisos').some(r => permiso.includes(r))) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();
        }
      },

      getDependencias() {
        var v = this;
        this.$http.get("cat_ente_publico").then(
          response => {
            this.dependencias = response.data.entes_publicos;
            this.dependencias.unshift({
              'codigo': 'T',
              'id': 0,
              'valor': 'Todas'
            });
            // this.model.dependencia_id = this.getKey('ente_publico_id');
          },
          error => {
            this.StepError(error);
          }
        );
      },
      getPeriodos() {
        var v = this;
        this.$http.get("getPeriodos").then(
          response => {
            this.periodos = response.data.periodos;
          },
          error => {
            this.StepError(error);
          }
        );
      },
      async getDirectorios() {
        this.$http.get("cron_directories").then(
          response => {
            this.directorios = response.data.directorios;
            var temp = [];
            Object.keys(this.directorios).forEach((t, i) => {

              let children = [];

              this.directorios[t].forEach((c, j) => {
                children.push({
                  id: i + '_' + j,
                  name: c.replaceAll('cron/', ''),
                });
              });

              temp.push({
                id: i,
                name: t,
                children: children,
              });

            });
            this.directorios = temp;
          },
          error => {
            this.StepError(error);
          }
        );
      },
      async getJsonFile(file) {
        this.fileInfo = {};
        this.file_name = '';
        this.dataExcelRegistro = [];
        this.dataExcelSinMovimientos = [];
        this.dataExcelErrores = [];
        if (file[0]) {
          var f = file[0];
          if (f.name) {
            if (f.name.includes('.json')) {
              this.loaddata = true;
              this.$http.post("cron_file", f).then(response => {
                  this.loaddata = false;
                  this.file_name = f.name.match(/([^\/]+)(?=\.\w+$)/)[0];
                  /*
                  [^\/]+    # one or more character that isn't a slash
                  (?=       # open a positive lookahead assertion
                    \.      # a literal dot character
                    \w+     # one or more word characters
                    $       # end of string boundary
                  )         # end of the lookahead
                  */
                  this.fileInfo = response.data.json;
                  // console.log(this.fileInfo);
                  this.dataExcelRegistro = this.fileInfo.registros;
                  this.dataExcelSinMovimientos = this.fileInfo.sinMovimientos;
                  this.dataExcelErrores = this.fileInfo.errores;
                  // this.campos_excel
                },
                error => {
                  this.StepError(error);
                  this.loaddata = false;
                }
              );
            }
          }
        }
        // file.search(/.json/i)

      },
      async runCron() {
        this.overlay = true;
        // setTimeout(() => {
        //   this.overlay = false
        // }, 3000);
        this.$http.get("set_tipo_dec_").then(response => {
            this.overlay = false;
            // ['inicio' =>  $start, 'fin' =>  $end, 'tiempo' =>  gmdate('H:i:s', $dif), 'total' => $total];
            var resp = response.data.response;
            var str = 'Tiempo de espera ' + resp.tiempo + ', Total de declaraciones asignadas: ' + resp.total;
            this.getDirectorios();
            this.OK(str);
          },
          error => {
            this.overlay = false;
            this.StepError(error);
          }
        );

      },
    },
    created() {
      this.getDependencias();
      this.getPeriodos();
      this.getDirectorios();
      this.rol = this.getKey('role');
      this.checkPermissions();

    },
    mounted() {

    }
  }

</script>
<style>
  .v-text-field.v-text-field--solo .v-input__control input {
    border: none !important;
  }

  .v-label.theme--dark {
    color: #fff !important;
  }

  .theme--light.v-divider {
    border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/CronAnual.vue